import React, { useEffect, useState, Fragment } from 'react';
type CountdownTimerProps = {
  size?: 'compact' | 'large';
  dark?: boolean;
};
type TimeParts = {
  hours: number;
  minutes: number;
  seconds: number;
};
function getTimeParts(target: number): TimeParts {
  const remaining = Math.max(0, target - Date.now());
  return {
    hours: Math.floor(remaining / 3600000),
    minutes: Math.floor(remaining % 3600000 / 60000),
    seconds: Math.floor(remaining % 60000 / 1000)
  };
}
export function CountdownTimer({
  size = 'compact',
  dark = false
}: CountdownTimerProps) {
  const [target] = useState(() => Date.now() + 86400000);
  const [time, setTime] = useState(() => getTimeParts(target));
  useEffect(() => {
    const interval = window.setInterval(() => setTime(getTimeParts(target)), 1000);
    return () => window.clearInterval(interval);
  }, [target]);
  const valueClass = size === 'large' ? 'text-5xl sm:text-7xl' : 'text-xl sm:text-2xl';
  const labelClass = size === 'large' ? 'text-[10px]' : 'text-[8px]';
  const parts: Array<[number, string]> = [[time.hours, 'ore'], [time.minutes, 'min'], [time.seconds, 'sec']];
  return <div className="flex items-start justify-center gap-2 sm:gap-3" aria-label={`L'offerta termina tra ${time.hours} ore, ${time.minutes} minuti e ${time.seconds} secondi`} data-id="element-21" data-mp="1gxov2quv8mhb">
      {parts.map(([value, label], index) => <Fragment key={label} data-id="element-22" data-mp="1uqmxgx5q7eud" data-mpi={index}>
          {index > 0 && <span aria-hidden="true" className={`${valueClass} font-display font-bold leading-none ${dark ? 'text-emerald-300' : 'text-[#241322]'}`} data-id="element-23" data-mp="1ut9avdfasoki">
              :
            </span>}
          <div className="text-center" data-id="element-24" data-mp="1pzy1p5n0jvpf">
            <div className={`${valueClass} font-display font-bold leading-none tabular-nums ${dark ? 'text-white' : 'text-[#241322]'}`} data-id="element-25" data-mp="1pyvb6ytlrva1">
              {String(value).padStart(2, '0')}
            </div>
            <div className={`${labelClass} mt-1 font-bold uppercase tracking-[.18em] ${dark ? 'text-[#B0B0C0]' : 'text-[#5A5A66]'}`} data-id="element-26" data-mp="2iilhc5j8qij4">
              {label}
            </div>
          </div>
        </Fragment>)}
    </div>;
}